import React from "react"
import { addressItem } from "../map-carnet-adresse.module.scss"
import PropTypes from "prop-types"
import AddressContent from "../AddressContent/address-content"
import EditButton from "../../../EditButton/edit-button"

const RenderAddresses = ({ addressesData }) => {
  return (
    <>
      {addressesData.map(({ node }) => (
        <li key={node.drupal_id} className={addressItem}>
          <EditButton link={"/node/" + node.drupal_internal__nid + "/edit"} />
          <AddressContent address={node} />
        </li>
      ))}
    </>
  )
}

RenderAddresses.propTypes = {
  addressesData: PropTypes.object.isRequired,
}

export default RenderAddresses
